import { combineReducers } from 'redux'

import Sidebar from './Sidebar'

export default combineReducers({
    Sidebar
})